module.exports = __webpack_public_path__ + "assets/img/jianbian.018c466c.png";